import React, { useEffect } from 'react'
import Loader from '../../layout/Loader'
import toast from 'react-hot-toast';
import {MDBDataTable} from 'mdbreact';
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import MetaData from '../../layout/MetaData'
import { useGetAdminUsersQuery, useDeleteUserMutation } from '../../../redux/api/userApi';
import AdminLayout from '../../layout/AdminLayout'
import "../../../css/Driver.css"

const ListPendingDrivers = () => {

  const {data, isLoading, error} = 
  useGetAdminUsersQuery();

 const [deleteUser, {error: deleteError, isLoading: isDeleteLoading, isSuccess}] = 
 useDeleteUserMutation()
 
 useEffect(() => {
      if(error){
        toast.error(error?.data?.message)
      }
      if(deleteError){
          toast.error(deleteError?.data?.message)
        }
      if(isSuccess){
          toast.success("User Deleted")
        }

    }, [error, deleteError, isSuccess]);

    const deleteUserHandler = (id) => {
      deleteUser(id)
    }

    const setUsers = () => {
      const users = {
          columns: [
              // {
              //     label: 'ID',
              //     field: 'id',
              //     sort: "asc",
              // },
              {
                  label: 'Name',
                  field: 'name',
                  sort: "asc",
              },
              {
                label: 'Phone Number',
                field: 'phoneNo',
                sort: "asc",
            },
              // {
              //     label: 'Email',
              //     field: 'email',
              //     sort: "asc",
              // },
              // {
              //     label: 'Role',
              //     field: 'role',
              //     sort: "asc",
              // },
              {
                  label: 'Actions',
                  field: 'actions',
                  sort: "asc",
              },
          ],
          rows: [],
      };
      data?.users?.filter(user => user.accountStatus === "Waiting for account approval by admin" && user.role === 'driver')?.forEach((user) => {
          users.rows.push({
              name: user?.name,
              phoneNo: user?.phoneNo,
              actions: (
              <> 
             {/* <Link to={`/admin/driver/update/${user?._id}`} className="btn btn-outline-primary" id='editbuttondrivers' > 
              <i className="fa fa-edit"></i>
              </Link> */}
             
              <Link to={`/admin/users/${user?._id}`} className="btn btn-outline-primary" > 
              <i className="fa fa-eye" ></i>
              </Link>

              </>
          ),
          });
      });

      return users
    }

    if(isLoading) return <Loader />;

  return (
    <AdminLayout> 
    <MetaData title ={'Pending Drivers'} />      
        <div>
        <h1 className='my-5'>{data?.users?.filter(user => user.accountStatus === "Waiting for account approval by admin" && user.role === 'driver').length} Pending Drivers</h1>
    
        <MDBDataTable 
        data={setUsers()}
        className='px-3'
        bvehicleed
        striped
        hover
        />
        </div>
    </AdminLayout>
  )
}

export default ListPendingDrivers
